@if (userService.currentUser()?.status === 'disabled') {
  <div class="disabled-banner">
    <span>Votre compte est en statut gratuit et limité.</span>
    <a routerLink="/subscribe">S'abonner pour seulement 15€ pour bénéficier du site sans limite</a>
  </div>
}
<router-outlet></router-outlet>